import React, { useState } from "react";
import media from "../../../media";
import TableLoader from "../../../components/atoms/Loader/tableLoader";
import moment from "moment/moment";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteStockThunk,
  inventoryListThunk,
  updateStockStatusThunk,
} from "../../../store/thunks/InventoryThunk";
import { StatusIcon } from "../../../components/atoms/tableListIcons/statusIcon";
import { Tooltip } from "antd";
import { DeleteIcon } from "../../../components/atoms/tableListIcons/deleteIcon";
import { DeleteModal } from "../../../components/atoms/tableListIcons/deleteModal";
import { Link } from "react-router-dom";
import UpdateSaleModal from "./updateSaleModal";
import TopRightLink from "../../../components/atoms/formFields/buttons/topRightLink";

const InvetoryTable = ({ list, pagination, loading, storeName, tabKey }) => {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state?.updateStockStatus || {});
  const [delStockId, setDelStockId] = useState();
  const [updateSale, setUpdateSale] = useState();
  const [discount, setDiscount] = useState();
  const inventoryId = pagination?.inventoryId;
  const [saleErrors, setSaleErrors] = useState({
    saleStartDate: "",
    saleEndDate: "",
  });
  return (
    <>
      <div className="table-responsive ">
        <table className="table table-bordered m-0 border radius-remove all_domain_table">
          <thead className="text-white bg-gray-700">
            <tr>
              <th className="font-size-lg all_table_id_number">S.No.</th>
              <th className="above-column">Product Type</th>
              <th className="above-column">Product Image</th>
              <th className="above-column">Product Name</th>
              <th className="above-column" nowrap="nowrap">
                Stock
              </th>
              <th className="above-column">MRP</th>
              <th className="above-column">Selling Price</th>
              <th className="above-column">Settlement Value</th>
              <th className="above-column">Sale</th>
              <th className="above-column">Published on</th>
              <th className="above-column">Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={10}>
                  <TableLoader />
                </td>
              </tr>
            ) : list?.length > 0 ? (
              list?.map((dataList, index) => {
                var expiredDate = ~~(
                  +new Date(dataList?.variantInfo[0]?.expirationDate) / 1000
                );
                var currentDate = ~~(+new Date() / 1000);
                const productBase = dataList?.productCategory;

                const variant = dataList?.variantInfo?.[0];
                return (
                  <React.Fragment key={index.toString()}>
                    <tr
                      className={
                        dataList?.variantInfo[0]?.variantStatus
                          ? ""
                          : "bg-gray-400"
                      }
                      key={index.toString()}
                    >
                      <td className="">
                        {index + 1 + pagination?.paginationFilter?.offset * 10}
                      </td>
                      <td className="text-left" nowrap="nowrap">
                        {dataList?.variantInfo?.length > 1 && (
                          <span
                            className="btn btn-icon btn-light btn-xs btn-hover-primary mr-5 view-button collapsed"
                            data-target={`#product_${index}_variant`}
                            data-toggle="collapse"
                          ></span>
                        )}
                        <span className="font-weight-bold">
                          {dataList?.productType?.en}
                        </span>
                      </td>
                      <td className="">
                        <img
                          src={
                            dataList?.variantInfo?.[0]?.productImage
                              ? dataList?.variantInfo[0]?.productImage
                              : media.Default
                          }
                          alt=""
                          className="max-w-70px"
                        />
                      </td>
                      <td className="font-weight-bolder text-left">
                        <span>
                          {dataList?.variantInfo[0]?.productName?.name?.en} -{" "}
                          {dataList?.variantInfo[0]?.variantName}
                        </span>
                        <span className="text-muted d-block">
                          SKU : {dataList?.variantInfo[0]?.productName?.sku}
                        </span>
                      </td>
                      <td className="" nowrap="nowrap">
                        <span className="d-block">
                          {dataList?.variantInfo[0]?.stock}
                        </span>
                        {expiredDate < currentDate && (
                          <span className="bg-danger px-3 py-1 text-white rounded font-size-sm">
                            LOT EXPIRED
                          </span>
                        )}
                      </td>
                      <td className="" nowrap="nowrap">
                        Rs. {dataList?.variantInfo[0]?.mrp}
                      </td>
                      <td className="" nowrap="nowrap">
                        Rs. {dataList?.variantInfo[0]?.sellingPrice}
                      </td>
                      <td className="" nowrap="nowrap">
                        {dataList?.variantInfo[0]?.settlementValue.toFixed(2)}
                      </td>

                      <td className="" nowrap="nowrap">
                        {dataList?.variantInfo[0]?.afterSalePrice ? (
                          <span className="font-weight-bolder d-block">
                            Rs. {dataList?.variantInfo[0]?.afterSalePrice}
                          </span>
                        ) : (
                          <span className="bg-danger px-3 py-1 text-white rounded font-size-sm">
                            NOT ON SALE
                          </span>
                        )}
                        {dataList?.variantInfo[0]?.sale && (
                          <span className="bg-dark d-inline-block mt-2 px-3 py-1 text-white rounded font-size-sm">
                            {" "}
                            {dataList?.variantInfo[0]?.sale}
                          </span>
                        )}
                      </td>
                      <td className="" nowrap="nowrap">
                        <span>
                          {dataList?.variantInfo[0]?.publishedOn
                            ? moment
                                .utc(dataList?.variantInfo[0]?.publishedOn)
                                .local()
                                .format("DD/MM/YYYY")
                            : ""}
                        </span>
                        <span className="text-muted d-block">
                          {dataList?.variantInfo[0]?.publishedOn
                            ? moment
                                .utc(dataList?.variantInfo[0]?.publishedOn)
                                .local()
                                .format("hh:mm A")
                            : ""}
                        </span>
                      </td>
                      <td>
                        <Tooltip
                          placement="top"
                          title={
                            dataList?.variantInfo[0]?.margin &&
                            dataList?.variantInfo[0]?.hsnCode
                              ? ""
                              : "Margin and HSN Code is required to update status, edit or put on sale. Please contact AK team to update the margin and the HSN Code."
                          }
                        >
                          <Tooltip
                            placement="top"
                            title={
                              dataList?.variantInfo[0]?.margin &&
                              dataList?.variantInfo[0]?.hsnCode
                                ? dataList?.variantInfo[0]?.status === "ACTIVE"
                                  ? "Hide product from mobile app"
                                  : "Show product on mobile app"
                                : ""
                            }
                          >
                            <span>
                              <StatusIcon
                                disabled={
                                  dataList?.variantInfo[0]?.variantStatus &&
                                  dataList?.variantInfo[0]?.margin &&
                                  dataList?.variantInfo[0]?.hsnCode
                                    ? false
                                    : true
                                }
                                checked={
                                  dataList?.variantInfo[0]?.status === "ACTIVE"
                                }
                                onChange={() => {
                                  dispatch(
                                    updateStockStatusThunk({
                                      productVariantInventory: {
                                        productId: dataList?.productId,
                                        variantId:
                                          dataList?.variantInfo[0]?.variantId,
                                        inventoryId: storeName,
                                      },
                                    }),
                                  )
                                    .unwrap()
                                    .then(() => {
                                      dispatch(
                                        inventoryListThunk({
                                          inventoryListingFilters: pagination,
                                        }),
                                      );
                                    })
                                    .catch((error) => {
                                      console.error("Status failed:", error);
                                    });
                                }}
                              />
                            </span>
                          </Tooltip>

                          <span className="mr-1 p-0">
                            <TopRightLink
                              onClick={(event) =>
                                dataList?.variantInfo[0]?.variantStatus
                                  ? ""
                                  : event.preventDefault()
                              }
                              disabled={!dataList?.variantInfo[0]?.margin}
                              url={{
                                pathname: `/editInventory/${
                                  dataList?.productId
                                }/${productBase?.split("/").pop()}`,
                                state: {
                                  Pagination:
                                    pagination?.paginationFilter?.offset,
                                  Filters: pagination,
                                  productId: dataList?.productId,
                                  productBase: dataList?.productBase,
                                  storeName: storeName,
                                },
                              }}
                            >
                              <span className="mr-2 p-0">
                                <i
                                  className={`flaticon-edit icon-md text-dark font-weight-bold text-hover-primary ${
                                    dataList?.variantInfo[0]?.variantStatus &&
                                    dataList?.variantInfo[0]?.margin
                                      ? "cursor-pointer"
                                      : "disabled"
                                  }`}
                                ></i>
                              </span>
                            </TopRightLink>
                          </span>

                          <span className="mr-1 p-0">
                            <i
                              className={`flaticon2-percentage icon-md sale-off font-weight-bold text-hover-primary ml-2 ${
                                dataList?.variantInfo[0]?.variantStatus &&
                                dataList?.variantInfo[0]?.margin
                                  ? "cursor-pointer"
                                  : "disabled"
                              }`}
                              data-toggle="modal"
                              data-target={`#updatesalemodal_variant${index}_${tabKey}`}
                              onClick={() =>
                                setUpdateSale({
                                  productId: dataList?.productId,
                                  variant: dataList?.variantInfo?.[0],
                                })
                              }
                            ></i>
                          </span>
                          <UpdateSaleModal
                            modalIdVariant={
                              dataList?.variantInfo[0]?.margin
                                ? `updatesalemodal_variant${index}_${tabKey}`
                                : ""
                            }
                            updateSale={updateSale}
                            setUpdateSale={setUpdateSale}
                            storeName={storeName}
                            setSaleErrors={setSaleErrors}
                            saleErrors={saleErrors}
                            discount={discount}
                            setDiscount={setDiscount}
                            pagination={pagination}
                          />
                        </Tooltip>

                        <DeleteIcon
                          // disabled={
                          //   !dataList?.variantInfo[0]?.variantStatus ||
                          //   !dataList?.variantInfo[0]?.margin
                          // }
                          onclick={() => {
                            setDelStockId({
                              productId: dataList?.productId,
                              variantId: dataList?.variantInfo[0]?.variantId,
                            });
                          }}
                        />
                      </td>
                    </tr>

                    {/*Product variant Row Start*/}
                    {dataList?.variantInfo?.slice(1).map((variants, i) => {
                      return (
                        <React.Fragment key={index.toString()}>
                          <tr
                            key={index.toString()}
                            className={`collapse ${
                              variants?.variantStatus ? "" : "bg-gray-400"
                            }`}
                            id={`product_${index}_variant`}
                          >
                            <td className=""></td>
                            <td className="" nowrap="nowrap"></td>
                            <td className="">
                              <img
                                src={
                                  variants?.productImage
                                    ? variants?.productImage
                                    : media.Default
                                }
                                alt=""
                                className="max-w-70px"
                              />
                            </td>
                            <td
                              className="font-weight-bold text-left"
                              nowrap="nowrap"
                            >
                              <span>
                                {variants?.productName?.name?.en} -{" "}
                                {variants?.variantName}
                              </span>
                              <span className="text-muted d-block">
                                SKU {variants?.productName?.sku}
                              </span>
                            </td>
                            <td className="">{variants?.stock}</td>
                            <td className="" nowrap="nowrap">
                              Rs. {variants?.mrp}
                            </td>
                            <td className="" nowrap="nowrap">
                              Rs. {variants?.sellingPrice}
                            </td>
                            <td className="" nowrap="nowrap">
                              {variants?.settlementValue.toFixed(2)}
                            </td>
                            <td className="" nowrap="nowrap">
                              {variants?.afterSalePrice ? (
                                <span className="font-weight-bolder d-block">
                                  Rs. {variants?.afterSalePrice}
                                </span>
                              ) : (
                                <span className="bg-danger px-3 py-1 text-white rounded font-size-sm">
                                  NOT ON SALE
                                </span>
                              )}
                              {variants?.sale && (
                                <span className="bg-dark d-inline-block mt-2 px-3 py-1 text-white">
                                  {variants?.sale}
                                </span>
                              )}
                            </td>
                            <td className="" nowrap="nowrap">
                              <span>
                                {variants?.publishedOn
                                  ? moment
                                      .utc(variants?.publishedOn)
                                      .local()
                                      .format("DD-MM-YYYY")
                                  : ""}
                              </span>
                              <span className="text-muted d-block">
                                {variants?.publishedOn
                                  ? moment
                                      .utc(variants?.publishedOn)
                                      .local()
                                      .format("hh:mm A")
                                  : ""}
                              </span>
                            </td>
                            <td>
                              <Tooltip
                                placement="top"
                                title={
                                  variants?.status === "ACTIVE"
                                    ? "Hide product from mobile app"
                                    : "Show product on mobile app"
                                }
                              >
                                <span>
                                  <StatusIcon
                                    disabled={
                                      variants?.variantStatus ? false : true
                                    }
                                    checked={variants?.status === "ACTIVE"}
                                    onChange={() => {
                                      dispatch(
                                        updateStockStatusThunk({
                                          productVariantInventory: {
                                            productId: dataList?.productId,
                                            variantId: variants?.variantId,
                                            inventoryId: storeName,
                                          },
                                        }),
                                      )
                                        .unwrap()
                                        .then(() => {
                                          dispatch(
                                            inventoryListThunk({
                                              inventoryListingFilters:
                                                pagination,
                                            }),
                                          );
                                        })
                                        .catch((error) => {
                                          console.error(
                                            "Status failed:",
                                            error,
                                          );
                                        });
                                    }}
                                  />
                                </span>
                              </Tooltip>

                              <span className="mr-1 p-0">
                                <Link
                                  onClick={(event) =>
                                    variants?.variantStatus
                                      ? ""
                                      : event.preventDefault()
                                  }
                                  to={{
                                    pathname: `/editInventory/${dataList?.productId}/${productBase}`,
                                    state: {
                                      productId: dataList?.productId,
                                      productBase: dataList?.productBase,
                                      storeName: storeName,
                                    },
                                  }}
                                >
                                  <i
                                    className={`flaticon-edit icon-md text-dark font-weight-bold text-hover-primary ${
                                      variants?.variantStatus
                                        ? "cursor-pointer"
                                        : "disabled"
                                    }`}
                                  ></i>
                                </Link>
                              </span>

                              <DeleteIcon
                                onclick={() => {
                                  setDelStockId({
                                    productId: variants?.productId,
                                    variantId: variants?.variantId,
                                  });
                                }}
                              />

                              <span className="mr-1 p-0">
                                <i
                                  className={`flaticon2-percentage icon-md sale-off font-weight-bold text-hover-primary ml-2 ${
                                    variants?.variantStatus
                                      ? "cursor-pointer"
                                      : "disabled"
                                  }`}
                                  data-toggle="modal"
                                  data-target={`#updatesalemodal_variant${i}_${tabKey}`}
                                  onClick={() =>
                                    setUpdateSale({
                                      productId: dataList?.productId,
                                      variant: variants,
                                    })
                                  }
                                ></i>
                              </span>
                            </td>
                          </tr>
                          <UpdateSaleModal
                            modalIdVariant={`updatesalemodal_variant${i}_${tabKey}`}
                            updateSale={updateSale}
                            pagination={pagination}
                            setUpdateSale={setUpdateSale}
                            storeName={storeName}
                            setSaleErrors={setSaleErrors}
                            saleErrors={saleErrors}
                            discount={discount}
                            setDiscount={setDiscount}
                          />
                        </React.Fragment>
                      );
                    })}

                    {/*Product variant Row End*/}
                  </React.Fragment>
                );
              })
            ) : (
              <tr>
                <td colSpan={10}>
                  {inventoryId
                    ? "No Data Found"
                    : "Please Select a Store to View the Records"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/*Delete Modal Start*/}
      <DeleteModal
        originalName="Stock"
        onClick={(e) => {
          e.preventDefault();
          dispatch(
            deleteStockThunk({
              productVariantInventory: {
                productId: delStockId.productId,
                variantId: delStockId.variantId,
                inventoryId: storeName,
              },
            }),
          )
            .unwrap()
            .then(() => {
              dispatch(
                inventoryListThunk({
                  inventoryListingFilters: pagination,
                }),
              );
            })
            .catch((error) => {
              console.error("Delete failed:", error);
            });
        }}
      />
      {/*Delete Modal End*/}
    </>
  );
};

export default InvetoryTable;
